import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Animatespin, AgencyCom } from "../../components/index";
import Functions from "./index.function";
const Agency = () => {
  const { isLoading, settings, AgencyData, baseURL } = Functions();
  return (
    <div className="bg-primary xs:py-5 sm:py-6 lg:pt-10">
      <div className="lg:px-5 xl:px-10 xs:px-3 sm:px-6 m-auto">
        <h2
          className={`text-xl sm:text-3xl lg:text-4xl uppercase font-unboundedBold text-secondary`}
        >
          Agency
        </h2>
      </div>
      <div className="lg:py-16 xs:py-5 sm:py-6">
        {isLoading ? (
          <Animatespin />
        ) : (
          <Slider {...settings}>
            {AgencyData?.records?.map((slide, index) => (
              <AgencyCom
                key={index}
                image={`${baseURL}/uploads/partneragency/logo/${slide?.logo}`}
                url={slide?.external_url}
                title={slide?.title}
              />
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default Agency;
